/* Blokların kare kimliğini adrese çeviren işlev — üretici ve önizleme için.

   Bilinen kareler (seçili işler, albümler, işler, yazı kapakları) içerikten
   geliyor: boyut ve alt metin onlarda. Arşive yeni yüklenmiş, henüz hiçbir
   albüme girmemiş bir kare için yalnızca R2 adresi var; boyutsuz basılıyor. */

import { pick } from '@frawgraphy/shared';
import type { PhotoRow, SiteContent } from '../content.ts';
import { mediaUrls, type UrlMode } from '../urls.ts';
import { designMediaUrl } from '../design.ts';
import type { RenderCtx } from './render.ts';

export function photoResolver(content: SiteContent, ctx: { lang: 'tr' | 'en'; mode: UrlMode }): RenderCtx['photo'] {
  const known = new Map<string, PhotoRow>();
  for (const p of content.featured) known.set(p.id, p);
  for (const w of content.works) known.set(w.photo.id, w.photo);
  for (const a of content.albums) for (const p of a.photos) known.set(p.id, p);
  for (const post of content.posts) if (post.coverPhoto) known.set(post.coverPhoto.id, post.coverPhoto);
  const urls = mediaUrls(ctx.mode, '');
  return (id) => {
    const p = known.get(id);
    if (!p) return { browse: designMediaUrl(id), full: `/media/full/${encodeURIComponent(id)}` };
    return {
      browse: urls.browse(p),
      full: urls.full(p),
      info: { id: p.id, width: p.width, height: p.height, alt: pick(p.alt, ctx.lang) }
    };
  };
}
